import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useEnvironment } from 'contexts/environment'
import { accentuate } from '../'
import { Section, ExternalLink, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'

const NetvisorHowToUse = () => {
    const { environment } = useEnvironment()

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_heading_how_to_use"
                    defaultMessage="How to use" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_netvisor_preamble_how_to_use_1"
                    defaultMessage="To get started, you will need a <strong>User ID</strong>, <strong>Key</strong>, and <strong>Business ID</strong>, provided by Netvisor. Read more about how to get them in our <link>Knowledge Base</link>."
                    values={{
                        strong: accentuate,
                        link: chunks => (
                            <ExternalLink href={`http://www.${environment.tld}/knowledge/integrations/netvisor`}>
                                {chunks}
                            </ExternalLink>
                        )
                    }} />
            </Paragraph>
        </Section>
    )
}

export default NetvisorHowToUse